import React, { Component } from "react";
import Vimeo from "@u-wave/react-vimeo";

// CSS
import "../../../css/training/video.css";

class VideoPlayer extends Component {
	render() {
		const {
			videoId,
			volume,
			paused,
			buffered,
			playedPercentage,
			statusText,
			setPlayHandler,
			handleVideoError,
			setVideoWatched,
			handleBufferedProgress,
			handlePlayedTimeUpdate,
			handleVolume
		} = this.props;

		return (
			<React.Fragment>
				<Vimeo
					className="video-player"
					video={videoId}
					width={640}
					height={480}
					volume={volume}
					paused={paused}
					background={true}
					onError={handleVideoError}
					onPlay={() => setPlayHandler(false)}
					onPause={() => setPlayHandler(true)}
					onProgress={handleBufferedProgress}
					onTimeUpdate={handlePlayedTimeUpdate}
					onEnd={setVideoWatched}
				/>
				<div className="vimeo-player--controls">
					<button
						className="vimeo-player--play-btn"
						onClick={() => setPlayHandler(!paused)}
					>
						<span className={paused ? "icon-play" : "icon-pause"} />
					</button>
					<div className="vimeo-player--status">
						<div
							className="vimeo-player--buffered"
							style={{ right: `${100 - buffered}%` }}
						/>
						<div
							className="vimeo-player--played"
							style={{ right: `${100 - playedPercentage}%` }}
						/>
						<div className="vimeo-player--status-text">{statusText && statusText}</div>
					</div>
					<div className="vimeo-player--volume">
						<input
							type="range"
							value={volume}
							min={0}
							max={1}
							step={0.01}
							onChange={handleVolume}
						/>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/components/training/videos/VideoPlayer.js